
import style from './style.scss'
import clsx from 'clsx'

const Button = ({ children, classnames = {}, ...props }) => {
  return (
    <button className={clsx(classnames, true && style.button)} {...props}>
      {children}
    </button>
  )
}
export default Button